import * as t from "io-ts";
import { GlobalColorV } from "@/types/colors";
import { StyleValue } from "vue/types/jsx";
import { MediaV } from "@/types/media";
import { inputValueInPixels } from "@/lib/singularity/brand/buttons-forms";

export const ColorScaleV = t.type({
  100: GlobalColorV,
  200: GlobalColorV,
  300: GlobalColorV,
  400: GlobalColorV,
  500: GlobalColorV,
  600: GlobalColorV,
  700: GlobalColorV,
  800: GlobalColorV,
  900: GlobalColorV
});

export const NamedColorPaletteV = t.type({
  label: t.string,
  primary: t.boolean,
  locked: t.boolean,
  base: GlobalColorV,
  scale: ColorScaleV,
  text: GlobalColorV
});

export const SingularityBrandColorV = t.type({
  neutral: t.union([NamedColorPaletteV, t.null]),
  primary: t.union([NamedColorPaletteV, t.null]),
  secondary: t.array(NamedColorPaletteV)
});

export type NamedColorPalette = t.TypeOf<typeof NamedColorPaletteV>;
export type ColorScale = t.TypeOf<typeof ColorScaleV>;
export type SingularityBrandColor = t.TypeOf<typeof SingularityBrandColorV>;

export type BorderRadiusLabelMap = {
  [key in keyof typeof BORDER_RADIUS_VALUES]: string;
};

export const BORDER_RADIUS_LABELS: BorderRadiusLabelMap = {
  none: "None",
  sm: "Small",
  md: "Medium",
  lg: "Large",
  full: "Full"
};

export const BORDER_RADIUS_VALUES = {
  none: inputValueInPixels(0),
  sm: inputValueInPixels(4),
  md: inputValueInPixels(16),
  lg: inputValueInPixels(24),
  full: inputValueInPixels(9999)
};

export const BUTTON_SIZE_LABELS = {
  sm: "Small",
  default: "Default",
  md: "Medium",
  lg: "Large"
};

export const ButtonSizeV = t.keyof(BUTTON_SIZE_LABELS);

export type ButtonSize = t.TypeOf<typeof ButtonSizeV>;

export const BorderRadiusV = t.keyof(BORDER_RADIUS_VALUES);

export type BorderRadius = t.TypeOf<typeof BorderRadiusV>;

export const SingularityBrandUIV = t.type({
  inputRadius: t.keyof(BORDER_RADIUS_VALUES),
  buttonSize: ButtonSizeV
});

export const SingularityBrandLogoV = t.type({
  logo: t.union([MediaV, t.null])
});

export const SingularityBrandV = t.type({
  color: SingularityBrandColorV,
  ui: SingularityBrandUIV,
  logo: SingularityBrandLogoV
});

export type SingularityBrandLogo = t.TypeOf<typeof SingularityBrandLogoV>;
export type SingularityBrand = t.TypeOf<typeof SingularityBrandV>;

export type ButtonStylePayload = {
  radius?: BorderRadius;
  size?: ButtonSize;
};

export type FormStylePayload = {
  radius?: BorderRadius;
};

export type SampleUICssStyles = {
  sampleUI?: StyleValue;
  label?: StyleValue;
  forms?: StyleValue;
  primary?: StyleValue;
  secondary?: StyleValue;
};
